module.exports = __webpack_public_path__ + "static/media/register.3d7200a0.png";